module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/moving_word_web-0245c8f7bd8c5933eef902387f7de9ba.png";